var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-spin',{attrs:{"spinning":_vm.spinning}},[_c('FullCalendar',{ref:"fullCalendar",staticClass:"neo-admin-calendar",attrs:{"eventTextColor":_vm.eventTextColor,"defaultView":"dayGridMonth","header":{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },"plugins":_vm.calendarPlugins,"weekends":true,"displayEventTime":true,"events":_vm.calendarEvents,"datesRender":_vm.handleDatesChange},on:{"dateClick":_vm.handleDateClick,"eventClick":_vm.handleEventClick}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }